import { defineComponent as r } from "vue";
import { screenSizeDetection as c } from "@sunrise/shared";
import { MsLocator as i } from "@sunrise/icons";
import a from "./index571.js";
const f = r({
  name: "MsHeaderRelocationToggle",
  components: {
    MsLocator: i,
    LocatedSvg: a
  },
  props: {
    location: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { isScreenL: t } = c();
    function o() {
      return e.location.id !== "deutschland";
    }
    function n() {
      return o() ? e.location.name : "";
    }
    return {
      getLocationName: n,
      isLocated: o,
      isScreenL: t
    };
  }
});
export {
  f as default
};
